import isEqual from 'lodash/isEqual';
import { Session } from '@silvertours/front-shared';
import { SearchHistoryItem, SearchHistoryType } from './types';

export const SEARCH_HISTORY_SESSION_STORAGE_KEY = 'SearchHistoryKey8934087340';
export const SEARCH_HISTORY_LIMIT = 6;

export const getSearchHistory = (): SearchHistoryType => {
  const data = Session.SessionStorageManager.getData(
    SEARCH_HISTORY_SESSION_STORAGE_KEY,
  );

  if (!Array.isArray(data)) {
    return { items: [] };
  }

  // @incomplete: better to check all fields
  return { items: data.filter(item => item && item.depLocation) };
};

export const addItemToSearchHistory = (item: SearchHistoryItem) => {
  const history: SearchHistoryType = getSearchHistory();
  if (!history.items.find(storedItem => isEqual(storedItem, item))) {
    history.items.unshift(item);
    if (history.items.length > SEARCH_HISTORY_LIMIT) {
      history.items.pop();
    }
    Session.SessionStorageManager.setData(
      SEARCH_HISTORY_SESSION_STORAGE_KEY,
      history.items,
    );
  }
};

export const clearSearchHistory = () => {
  Session.SessionStorageManager.removeData(SEARCH_HISTORY_SESSION_STORAGE_KEY);
};
